module.exports = __webpack_public_path__ + "img/02.40bb27c7.svg";